import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';
import { cn } from 'utils/classNamesTailwind';
import { Tile } from 'components/Layout/PageContainer';
import { TbIcon } from 'components/Figma';

export interface ReportLinkProps {
  linkTextTranslationId: string;
  linkUrl: string;
  className?: string;
}

export interface ReportLinkCardProps {
  titleId: string;
  descriptionId: string;
  linkUrl: string;
  className?: string;
}

export function ReportLinkCard({ titleId, descriptionId, linkUrl, className = '' }: ReportLinkCardProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(linkUrl + location.search);
  };

  return (
    <Tile
      id={`report-link-${titleId}`}
      onClick={handleNavigate}
      className={cn('group py-3 px-4 flex flex-col gap-1.5', className)}
    >
      <div className="flex items-center gap-1.5">
        <TbIcon name="Table" />
        <p className="text-base font-bold group-hover:text-denim-500 underline">
          <FormattedMessage id={titleId} />
        </p>
      </div>
      <p className="text-sm font-normal">
        <FormattedMessage id={descriptionId} />
      </p>
    </Tile>
  );
}
